<template>
  <div class="form-container" style="position: relative">
    <el-form ref="form" label-position="top" :model="formLabelAlign" label-width="80px" class="order-form">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('order_no')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.no" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('order_status')" style="width: 100%">
            <el-select v-model.number="formLabelAlign.status" disabled class="gray-theme" filterable
              style="width: 100%">
              <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8"
          v-if="formLabelAlign.status === 40 || formLabelAlign.status === 50 || formLabelAlign.status === 80">
          <el-form-item :label="$t('status')" style="width: 100%">
            <el-select disabled class="gray-theme" placeholder="" style="width: 100%">
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-else>
          <el-form-item :label="$t('status')" style="width: 100%">
            <el-select v-model.number="formLabelAlign.paymentStatus" disabled class="gray-theme" filterable
              style="width: 100%">
              <el-option v-for="item in payStatusOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('product')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.productName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('user_qty')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.userNumber" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('user_month')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.monthNumber" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('currency')" style="width: 100%">
            <el-select v-model="formLabelAlign.currency" disabled class="gray-theme" style="width: 100%" filterable>
              <el-option v-for="item in currencyListData" :key="item.code" :label="item.code" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('amount')" prop="amount" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.payableAmount" :disabled="readModel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="order-form-title">{{ $t('buyer_info') }}</div>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('buyer')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.buyer" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('email')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.email" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('cellphone')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.telephone" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('company')" style="width: 100%">
            <el-input class="gray-theme" v-model="formLabelAlign.company" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="order-form-title">{{ $t('time_info') }}</div>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('payment_date')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.paymentDate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('active_date')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.activeDate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('expire_date')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.deadline" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import commonApi from '@/apis/common';
import { mapState } from 'vuex';
export default {
  data() {
    var checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback();
        return;
      }
      if (!this.$formValidation.twoPointreg.test(value)) {
        callback(new Error('Money format error '));
        return;
      }
      if (value < 0 || value > 9999999999999.99) {
        callback(new Error('Money format error '));
        return;
      }
      callback();
    };
    return {
      formLabelAlign: {
        no: '',
        createdTime: '',
        status: '',
        productName: '',
        userNumber: '',
        monthNumber: '',
        payableAmount: '',
        buyer: '',
        email: '',
        phone: '',
        currency: '',
        company: '',
        paymentdate: '',
        activedate: '',
        deadline: ''
      },
      statusOptions: [
        {
          name: this.$t('submitted'),
          code: 10
        },
        {
          name: this.$t('canceled'),
          code: 20
        },
        {
          name: this.$t('completed'),
          code: 30
        },
        {
          name: this.$t('apply_trial'),
          code: 40
        },
        {
          name: this.$t('on_trial'),
          code: 50
        },
        {
          name: this.$t('trial_reject'),
          code: 80
        }
      ],
      payStatusOptions: [
        {
          name: ' ',
          code: 0
        },
        {
          name: this.$t('unpaid'),
          code: 10
        },
        {
          name: this.$t('paid'),
          code: 20
        },
        {
          name: this.$t('refunded'),
          code: 30
        }
      ],
      currencyListData: []
    };
  },

  props: {
    rowData: {
      type: Object,
      default: () => { }
    },

    readModel: {
      type: Boolean,
      default: true
    }
  },

  components: {},

  computed: {
    ...mapState(['userInfo'])
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.formLabelAlign = this.rowData;
      // this.getCurrency();
    }

    // async getCurrency() {
    //   const req = {};
    //   const res = await commonApi.getCurrency(req);
    //   console.log(res);
    //   this.currencyListData = res.list;
    // }
  }
};
</script>
<style lang="scss">
.order-form {
  .el-form-item__label {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0;
  }

  .el-form-item__content {
    text-align: left;

    .el-textarea__inner {
      height: 80px;
    }
  }
}

.order-form-title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: #292929;
  padding: 30px 0;
}

.line {
  height: 1px;
  background: #f4f4f4;
}

.dialog-class {
  border-radius: 14px !important;

  .el-dialog__header {
    background-color: #f4f4f4;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 50px 0 31px 50px;
  }

  .el-dialog__body {
    // height: 50vh;
    overflow: auto;
    padding: 40px 165px 0;
  }
}
</style>
